module.exports = __webpack_public_path__ + "fonts/finder-iconsa5d4.ccbc01d.ttf";